<template>
  <div id="sideMenu">
    <!--    <img id="bannerTet" src="../../assets/img/banner_tet.png">-->
    <select-branch />
    <list-menu />
    <!--    <menu-brand-tet />-->
    <menu-brand />
  </div>
</template>

<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import SelectBranch from "./select-branch";

export default {
  name: "main-menu",
  data() {
    return {
      settings: {
        maxScrollbarLength: 350
      }
    };
  },
  components: {
    SelectBranch,
    VuePerfectScrollbar,
    listMenu: () => import("./list-menu.vue"),
    menuBrand: () => import("./menu-brand.vue")
    // menuBrandTet: () => import("./menu-brand-tet.vue")
  }
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/menu-left/main-menu.vue